import activityPanelStyles from './activityPanelStyles';

const activityLoggingPanelStyles = (theme) => ({
  ...activityPanelStyles(theme),
  activityLoggingPanel: {
    padding: '0 10px 10px 10px',
  },
  activitySelectDiv: {
    display: 'inline-block',
    width: '30%',
  },
  activityDirectionDiv: {
    display: 'inline-block',
    width: '15%',
    marginLeft: '5%',
  },
  activityLiteralWithDiv: {
    display: 'inline-block',
    width: '12%',
    marginLeft: '8%',
    position: 'relative',
    top: '18px',
    fontWeight: 400,
  },
  activityPartnerDiv: {
    display: 'inline-block',
    width: '45%',
    marginLeft: '5%',
  },
  dateTimePanelComponentDateDiv: {
    display: 'inline-block',
    width: '162px',
  },
  buttonsDiv: {
    display: 'inline',
    float: 'right',
  },
});

export default activityLoggingPanelStyles;
